import { TTerminationRight } from '@brickwise/asset-validation/dist/schema/enums';
import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultSelectField } from 'src/components/mui-overrides/SelectTextField';

interface Props {
  disabled?: boolean;
}

export const TerminationRightSelector: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const formik = useFormikContext();

  return (
    <DefaultSelectField
      disabled={disabled}
      fieldName="investmentDetails.terminationRight"
      label={t('dashboard.assets.addedit.investment.securitytype.fields.terminationRight')}
      formik={formik}
      options={[
        {
          value: TTerminationRight.issuer,
          label: t('general.terminationRight.issuer'),
        },
        {
          value: TTerminationRight.investor,
          label: t('general.terminationRight.investor'),
        },
        {
          value: TTerminationRight.issuerAndInvestor,
          label: t('general.terminationRight.issuerAndInvestor'),
        },
        {
          value: TTerminationRight.no,
          label: t('general.terminationRight.no'),
        },
      ]}
    />
  );
};
